import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.013rem',
    height: '1rem',
  },
});

const CalendarIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 16.2 16" className={styles.icon}>
      <path
        d="M13.3872 13.3333H10.7176V10.6667H13.3872V13.3333ZM9.38276 6.66667H6.71313V9.33333H9.38276V6.66667ZM13.3872 6.66667H10.7176V9.33333H13.3872V6.66667ZM5.37832 10.6667H2.70869V13.3333H5.37832V10.6667ZM9.38276 10.6667H6.71313V13.3333H9.38276V10.6667ZM5.37832 6.66667H2.70869V9.33333H5.37832V6.66667ZM16.0568 1.33333V16H0.0390625V1.33333H2.04128V2C2.04128 2.73533 2.63995 3.33333 3.3761 3.33333C4.11225 3.33333 4.71091 2.73533 4.71091 2V1.33333H11.385V2C11.385 2.73533 11.9836 3.33333 12.7198 3.33333C13.4559 3.33333 14.0546 2.73533 14.0546 2V1.33333H16.0568ZM14.722 5.33333H1.37388V14.6667H14.722V5.33333ZM13.3872 0.666667C13.3872 0.298667 13.0889 0 12.7198 0C12.3507 0 12.0524 0.298667 12.0524 0.666667V2C12.0524 2.368 12.3507 2.66667 12.7198 2.66667C13.0889 2.66667 13.3872 2.368 13.3872 2V0.666667ZM4.0435 2C4.0435 2.368 3.74517 2.66667 3.3761 2.66667C3.00702 2.66667 2.70869 2.368 2.70869 2V0.666667C2.70869 0.298667 3.00702 0 3.3761 0C3.74517 0 4.0435 0.298667 4.0435 0.666667V2Z"
        fill="white"
        fillOpacity="0.87"
      />
    </SvgIcon>
  );
};

export default memo(CalendarIcon);
